import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { CorporateRegistrationApprovalModel } from "../models/corporate-registration-approval.model";

@Injectable({
  providedIn: 'root',
})
export class CorporateRegistrationApprovalService {

  constructor(
    private httpClient: HttpClient
  ) {}

  public getApproval(
    approvalId: string
  ): Observable<CorporateRegistrationApprovalModel> {
    return this.httpClient.get<CorporateRegistrationApprovalModel>(
      Configuration.getApiBaseUrl() + `/corporate-registration-approvals/${approvalId}`
    );
  }

  public approve(approvalId: string): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + `/corporate-registration-approvals/${approvalId}/approve`,
      {}
    );
  }

  public reject(approvalId: string): Observable<void> {
    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + `/corporate-registration-approvals/${approvalId}/reject`,
      {}
    );
  }
}